<template>
    <div>
   <!-- Start -->
   <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800" id="contact">
     <div class="container">
       <div class="grid grid-cols-1 pb-8 text-center">
         <h3 class="mb-4 md:text-2xl text-xl font-medium">Contactez-nous</h3>

         <p class="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">
           Une question, un besoin ou envie d’en savoir plus ?
           Nous sommes à votre disposition pour vous accompagner dans la gestion de votre paie.
         </p>
       </div><!--end grid-->

       <div class="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 mt-8 items-center gap-[30px]">
         <div class="lg:col-span-8">
           <div class="p-6 rounded-md shadow bg-white dark:bg-slate-900">
             <form>
               <div class="grid lg:grid-cols-12 lg:gap-[30px]">
                 <div class="lg:col-span-6 mb-5">
                   <input name="name" id="name" type="text"
                          class="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit
                                   dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded outline-none
                                   focus:border-violet-600/50 dark:focus:border-violet-600/50 focus:ring-0"
                          placeholder="Nom :">
                 </div>

                 <div class="lg:col-span-6 mb-5">
                   <input name="email" id="email" type="email"
                          class="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit
                                   dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded outline-none
                                   focus:border-violet-600/50 dark:focus:border-violet-600/50 focus:ring-0"
                          placeholder="Email :">
                 </div><!--end col-->
               </div>

               <div class="grid grid-cols-1">
                 <div class="mb-5">
                   <input name="subject" id="subject"
                          class="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit
                                   dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded outline-none
                                   focus:border-violet-600/50 dark:focus:border-violet-600/50 focus:ring-0"
                          placeholder="Sujet :">
                 </div>

                 <div class="mb-5">
                            <textarea name="comments" id="comments"
                                      class="form-input w-full py-2 px-3 bg-transparent border border-inherit
                                      dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded outline-none
                                      focus:border-violet-600/50 dark:focus:border-violet-600/50 focus:ring-0 h-28"
                                      placeholder="Message :"></textarea>
                 </div>
               </div>
               <button type="submit" id="submit" name="send"
                       class="py-2 px-5 inline-block font-normal tracking-wide border align-middle
                            transition duration-500 ease-in-out text-base text-center bg-violet-600
                            hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-md">
                 Envoyer le message
               </button>
             </form>
           </div>
         </div>

         <div class="lg:col-span-4">
           <div class="lg:ms-8">

             <div class="flex">
               <div class="icons text-center mx-auto">
                 <i class="uil uil-phone block rounded text-2xl dark:text-white mb-0"></i>
               </div>

               <div class="flex-1 ms-6">
                 <h5 class="text-lg dark:text-white mb-2 font-medium">Téléphone</h5>
                 <a href="tel:+33661916637" class="text-slate-400">06 61 91 66 37</a>
               </div>
             </div>

             <div class="flex mt-4">
               <div class="icons text-center mx-auto">
                 <i class="uil uil-envelope block rounded text-2xl dark:text-white mb-0"></i>
               </div>

               <div class="flex-1 ms-6">
                 <h5 class="text-lg dark:text-white mb-2 font-medium">Email</h5>
                 <a href="mailto:contact@rhpaieplus.fr" class="text-slate-400">contact@rhpaieplus.fr</a>
               </div>
             </div>

             <div class="flex mt-4">
               <div class="icons text-center mx-auto">
                 <i class="uil uil-map-marker block rounded text-2xl dark:text-white mb-0"></i>
               </div>

               <div class="flex-1 ms-6">
                 <h5 class="text-lg dark:text-white mb-2 font-medium">Adresse</h5>
                 <p class="text-slate-400 mb-2">18 RUE DE LA CONCERTATION, 75018 PARIS</p>
               </div>
             </div>

           </div>
         </div>
       </div><!--end grid-->
     </div><!--end container-->
        </section><!--end section-->
        <!-- End -->
    </div>
</template>

<script>
    export default {
        name: "GetInTouch"
    }
</script>

<style lang="scss" scoped>

</style>